var GoogleAddressField = require("../../../../scripts/classes/GoogleAddressField");

/**
The individual object representing a single loss location.
This would be expanded upon to include multiple input elements
**/

var LossLocation = function(address, city, state, zip){

    var editStr = 'Edit';
    if (window.Language == "spanish")
    {
        editStr = 'Editar';
    }

    this.$el = $('<div class="loss-location column small-10 medium-9 large-7"><div class="form-item"><div class="remove-btn"></div><span class="loss-location-text"></span><div class="edit-btn">' + editStr + '</div></div></div>');
    this.$el.find('.loss-location-text').text(address + ' ' + city + ', ' + state + ' ' + zip);

    this.addr = address;
    this.city = city;
    this.state = state;
    this.zip = zip;
};

// adding the elements to the dom
LossLocation.prototype.addToDOM = function(){

    // remove error message if it's shown
    $('#js-loss-loc-error').hide();
    $("#loss-locations-wrap").append(this.$el);

};

// removing the elements from the dom
LossLocation.prototype.removeFromDOM = function(){

    this.$el.remove();

};

// update the loss location
// this function updates the element and replaces it in the dom
LossLocation.prototype.update = function(address, city, state, zip){

    var editStr = 'Edit';
    if (window.Language == "spanish")
    {
        editStr = 'Editar';
    }

    var $updatedEl = $('<div class="loss-location column small-10 medium-9 large-7"><div class="form-item"><div class="remove-btn"></div><span class="loss-location-text"></span><div class="edit-btn">' + editStr + '</div></div></div>');
    $updatedEl.find('.loss-location-text').text(address + ' ' + city + ', ' + state + ' ' + zip);

    // replace the element in the dom
    this.$el.replaceWith($updatedEl);

    // point this object to the updated element
    this.$el = $updatedEl;

    // update this objects variables
    this.addr = address;
    this.city = city;
    this.state = state;
    this.zip = zip;

};

// this updates the form fields associated with this loss location
/*
LossLocation.prototype.updateFormFields = function(lossLocId){
    var lossLocFieldId = lossLocId + 1; // form fields are 1 indexed
console.log('update form fields: ' + lossLocFieldId + ' ' + this.addr);
    $('#loss-loc-address-' + lossLocFieldId).val(this.addr);
    $('#loss-loc-city-' + lossLocFieldId).val(this.city);
    $('#loss-loc-state-' + lossLocFieldId).val(this.state);
    $('#loss-loc-zip-' + lossLocFieldId).val(this.zip);
};
*/

// updating the id of the loss location, based on the total number of active loss locations
// inside the DOM
LossLocation.prototype.updateId = function(index){
    this.$el.attr("data-loss-location-id", index);
};

LossLocation.prototype.getAddress = function(){
    return this.addr;
};

LossLocation.prototype.getCity = function(){
    return this.city;
};

LossLocation.prototype.getState = function(){
    return this.state;
};

LossLocation.prototype.getZip = function(){
    return this.zip;
};




/**
A controller object that handles the macro-level interactions
for Loss Locations field itself. This is what show/hides the modal
and creates individual LossLocation objects, which get added/removed
from the DOM
**/
var LossLocationController = function(){

    var self = this;

    // a property to hold all our active loss locations
    this.lossLocations = [];

    // set the modal for use later
    this.$modal = $('#loss-location-modal');

    // variable to keep track of if we're editing or not when the modal is open
    this.isEditingId = -1;

    // get our modal fields
    this.$fieldAddr  = $('#loss-loc-addr');
    this.$fieldCity  = $('#loss-loc-city');
    this.$fieldState = $('#loss-loc-state');
    this.$fieldZip   = $('#loss-loc-zip');

    // event handler to add a location
    $("#add-location").click(function(){
        self.isEditingId = -1;
        lossLocFormValidator.resetForm();
        self.showModal();
    });

    // event handler to hide the modal
    $('#loss-location-modal .close').click(function(){
        self.hideModal();
    });

    // event handler for when modal is submitted
    $('#submit-loss-location').click(function(){

        console.log($('#add-loss-loc-form').valid());
        $('#add-loss-loc-form').validate();
        if(!$('#add-loss-loc-form').valid())
        {
            return;
        }

        self.submit(self.isEditingId);

        if (self.lossLocations.length >= 5)
        {
            $('#add-location').hide();
        }

    });

    // We're binding this event onto the body, so any
    // loss locations created "in the future" will be handled
    // from this method. We're doing it here, rather than in the
    // Loss Location object so we have access to the this.lossLocations
    // array. -- This is a little janky, but oh well..
    $("#loss-locations-wrap").on("click", ".remove-btn", function(e){
        e.preventDefault();
        self.remove(this);

        if (self.lossLocations.length < 5)
        {
            $('#add-location').show();
        }
    });

    // edit buttons
    $('#loss-locations-wrap').on("click", ".edit-btn", function(e){
        e.preventDefault();
        // get the ID of the loss location being edited
        var $el = $(this);
        var lossLocationId = Number($el.parents('.loss-location').data("loss-location-id"));
        self.isEditingId = lossLocationId;
        self.showModal(lossLocationId);
    });

    var lossLocFormValidator = $('#add-loss-loc-form').validate({
        rules: {
            "loss-loc-addr": {
                required: true
            },
            "loss-loc-city": {
                required: true
            },
            "loss-loc-state": {
                required: true
            },
            "loss-loc-zip": {
                required: true
            }
        },
        errorPlacement: function(error, element) {
            if (element.attr("type") == "text") {
                error.appendTo( element.closest("div.field") );
            }
            else {
                error.appendTo( element.closest("div") );
            }
        }
    });

    this.initGoogleAddressField();

};

/**
 * Init'ing our Google Shipping Address Fields
 */
LossLocationController.prototype.initGoogleAddressField = function(){

    var self = this;
    var $addressField = $("#loss-loc-addr");

    var googleAddressField = new GoogleAddressField({
        $addressField: $addressField,
        fields: {
            $address: $("#loss-loc-addr"),
            $city: $("#loss-loc-city"),
            $state: $("#loss-loc-state"),
            $zipcode: $("#loss-loc-zip")
        },
        callback: function(){

        }
    });

    googleAddressField.init();

};

LossLocationController.prototype.submit = function(lossLocId){

    if (lossLocId == -1)
    {
        this.add(
            this.$fieldAddr.val(),
            this.$fieldCity.val(),
            this.$fieldState.val(),
            this.$fieldZip.val()
        );
    }
    else
    {
        console.log('editing: ' + lossLocId);
        this.updateLocation(
            lossLocId,
            this.$fieldAddr.val(),
            this.$fieldCity.val(),
            this.$fieldState.val(),
            this.$fieldZip.val()
        );
    }

    this.hideModal();
}

LossLocationController.prototype.showModal = function(lossLocId = -1){

    this.updateModalFields(lossLocId);

    if (window.matchMedia("(max-width: 480px)").matches) {
      $('body').addClass('fixed-body'); // adding this class fixes a bug in iOS 11 safari
    }

    this.$modal.show();
    this.$modal.fadeTo(10, 1);
    $('.modal-wrap').css('display', 'flex');
    $('.modal-overlay').show();
    $('.modal-overlay').fadeTo(10, 1);

};

LossLocationController.prototype.updateModalFields = function(lossLocId){
    if (lossLocId == -1)
    {
        // adding new location, clear fields
        $('#loss-location-modal').find('input:text').val('');
    }
    else
    {
        // editing location, fill in fields
        var lossLocation = this.lossLocations[lossLocId];
        this.$fieldAddr.val(lossLocation.getAddress());
        this.$fieldCity.val(lossLocation.getCity());
        this.$fieldState.val(lossLocation.getState());
        this.$fieldZip.val(lossLocation.getZip());
    }
};

LossLocationController.prototype.hideModal = function(){

    $('body').removeClass('fixed-body');
    if (window.matchMedia("(max-width: 480px)").matches) {
        $(window).scrollTop( $('#loss-locs-section').offset().top ); // scroll back, because adding fixed scrolls to top
    }

    this.$modal.hide();
    this.$modal.css('opacity', '0');
    $('.modal-overlay').hide();
    $('.modal-wrap').css('display', 'none');
    $('.modal-overlay').css('opacity', '0');

};

// where we create individual Loss Locations, and add them
// into the lossLocations array
LossLocationController.prototype.add = function(address, city, state, zip){

console.log('add: ' + address);

    var lossLocation = new LossLocation(address, city, state, zip);
    lossLocation.addToDOM();
    this.lossLocations.push(lossLocation);
    this.updateLocationIds();
    this.updateLocationFormFields();

};

// where we remove invidual loss locations from the DOM
LossLocationController.prototype.remove = function(el){

    var $el = $(el);
    var lossLocationId = Number($el.parents('.loss-location').data("loss-location-id"));
    this.lossLocations[lossLocationId].removeFromDOM();
    this.lossLocations.splice(lossLocationId, 1);
    this.updateLocationIds();
    this.updateLocationFormFields();

};

// this updates an existing loss location
LossLocationController.prototype.updateLocation = function(lossLocId, address, city, state, zip){
    this.lossLocations[lossLocId].update(address, city, state, zip);
    this.updateLocationIds();
    this.updateLocationFormFields();
};

// after we add or remove from the DOM we need to update IDs
// to refect the new organization of the active arrays
LossLocationController.prototype.updateLocationIds = function(){
    $('.js-loss-location-field').val('');
    $.each(this.lossLocations, function(index){
        var lossLocation = this;
        lossLocation.updateId(index);
    });

}

// this function updates the form fields associated with each loss location
LossLocationController.prototype.updateLocationFormFields = function(){
    /*
    $.each(this.lossLocations, function(index){
        var lossLocation = this;
        lossLocation.updateFormFields(index);
    });
    */


    // get our loss locations input wrapper
    var $lossLocsFieldWrap = $('#loss-locations-table-fields-wrapper');

    // clear our loss location form fields out
    $lossLocsFieldWrap.html('');

    // go through this.lossLocations and add table inputs for each location
    $.each(this.lossLocations, function(index){

        var lossLocation = this;
        var lossLocFieldId = index + 1; // form fields are 1-indexed

        // address
        $('<input type="text" />')
            .attr('name', 'fields[lossLocations][' + lossLocFieldId +'][lossAddress]')
            .val(lossLocation.addr)
            .appendTo($lossLocsFieldWrap);

        // city
        $('<input type="text" />')
            .attr('name', 'fields[lossLocations][' + lossLocFieldId +'][lossCity]')
            .val(lossLocation.city)
            .appendTo($lossLocsFieldWrap);

        // state
        $('<input type="text" />')
            .attr('name', 'fields[lossLocations][' + lossLocFieldId +'][lossState]')
            .val(lossLocation.state)
            .appendTo($lossLocsFieldWrap);

        // zip
        $('<input type="text" />')
            .attr('name', 'fields[lossLocations][' + lossLocFieldId +'][lossZip]')
            .val(lossLocation.zip)
            .appendTo($lossLocsFieldWrap);

    });

};

export default LossLocationController;
